import React from 'react';
import './Modal.css';
import plannerIcon from "../../assets/images/Icon=planner.svg";
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import Textarea from '../designSystem/TextArea';
import { t } from '../../locales/translate';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const RejectPlanModal = ({ isVisible, onClose, onRejectClick, isLoading, message, setMessage, error }) => {
    const [loading, setLoading] = React.useState(false);

    const handleReject = async () => {
        setLoading(true);
        try {
            await onRejectClick();
        } catch (error) {
            console.error("Error rejecting:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <LoadingOverlay isVisible={loading} />
                    <div className={loading ? 'blur' : ''}>
                        <div className='content-container'>                       
                            <div className='icon-container'>
                                <img src={plannerIcon} alt="Reject Plan" />
                            </div>
                            <div className='text-container'>
                                <Heading6Semibold color='#1E293B' text={t("rejectPlan")} />
                                <BodyMediumRegular
                                    color='#384153'
                                    text={t("rejectPlanTip")}
                                    textAlign='center'
                                />
                            </div>
                            <div style={{ marginTop: '-8px', marginBottom: '8px', width: '100%' }}>
                                <Textarea
                                    label={t("notes")}
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)} 
                                    error={error}
                                    placeholder={t("addSuggestionsHere")}
                                />
                            </div>
                        </div>
                        <div className='button-contiainer'>
                            <button className='cancel-button'
                                onClick={onClose}
                            >
                                {t("cancel")}
                            </button>
                            <button className='danger-button' onClick={handleReject} disabled={loading}>
                                {t("rejected")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default RejectPlanModal;